import { render, staticRenderFns } from "./BudgetCategoryTable.vue?vue&type=template&id=60b91539&scoped=true"
import script from "./BudgetCategoryTable.vue?vue&type=script&lang=js"
export * from "./BudgetCategoryTable.vue?vue&type=script&lang=js"
import style0 from "./BudgetCategoryTable.vue?vue&type=style&index=0&id=60b91539&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b91539",
  null
  
)

export default component.exports